<div class="row container">
    <div class="faq-container">
        <p class="faq-text pt-3">{{properties.termsAndConditions.forMoreInfo}}
            <a (click)="redirectToFAQ()" class="links__action__default faq" tabindex="0">{{properties.termsAndConditions.faq}}</a>
            and <span (click)="openTerms(userSubscriptionDetails, userInfo)" (keydown.enter)="openTerms(userSubscriptionDetails, userInfo)" class="links__action__default faq"
                      role="link"
                      tabindex="0">
                    {{properties.termsAndConditions.termsNconditions}}</span>
        </p>
    </div>
</div>

